<ng-container *ngIf="appearance=='legacy'">
    <div class="relative">
        <img src="assets/svg/sector/search_icon.svg" class="search-ic"> <input class="trigger-btn sl-search"
            (click)="onFilterChange(null,true)" [formControl]="FilterCtrl" #trigger="cdkOverlayOrigin" cdkOverlayOrigin
            [placeholder]="selectedLabel ||customLabel || label" [style.border-radius]="borderRadius">
    </div>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen"
        (overlayOutsideClick)="menuClickOutside($event)">

        <div class="bubble">
            <ng-scrollbar pointerEventsMethod="scrollbar" appearance="standard"
                [style.height.px]="innerContent.offsetHeight?innerContent.offsetHeight:(selectList.length*31)+30"
                class="c-scroll sc-select">
                <div class="select-inner" #innerContent>
                    <button *ngFor="let value of filteredList | async"
                        (click)="toggleSelectValue(value._id, value,$event)">
                        <div class="select-row items-center py-1">
                            <span class="filter-list__input input-check pointer-events-none" *ngIf="multiple">
                                <span class="input-check__body">
                                    <input class="input-check__input" type="checkbox" [checked]="value.selected">
                                    <span class="input-check__box"></span>
                                    <app-icon class="input-check__icon" name="check-9x7" size="9x7">
                                    </app-icon>
                                </span>
                            </span>
                            <span class="text">{{ translateHelper.localize(value?.name) }}</span>
                        </div>
                    </button>
                </div>
            </ng-scrollbar>
        </div>
    </ng-template>

</ng-container>

<ng-container *ngIf="appearance=='filter'">
    <div class="widget-filters__list">
        <div class="widget-filters__item" [class.filter-show_more]="selectList?.length > 5">
            <div class="filter filter--opened" appCollapseItem="filter--opened" #collapse="appCollapseItem">

                <button type="button" class="filter__title" (click)="collapse.toggle()">
                    <span class="me-2">•</span> {{customLabel|| label}}
                    <!--  <img src="assets/svg/filters/collapse_arrow.svg" class="collapse-arrow"> -->
                </button>
                <div class="filter__body" appCollapseContent>
                    <div class="filter__container">
                        <div class="relative fl-search">
                            <input class="trigger-btn" (click)="onFilterChange(null,true)" [formControl]="FilterCtrl"
                                #trigger="cdkOverlayOrigin" cdkOverlayOrigin
                                [placeholder]="selectedLabel ||customLabel || label">
                        </div>
                        <div class="filter-list">
                            <div class="filter-list__list">
                                <ng-scrollbar *ngIf="(filteredList | async)?.length" pointerEventsMethod="scrollbar"
                                    appearance="standard" [style.height.px]="filterList.offsetHeight+20"
                                    class="c-scroll sc-select">

                                    <div #filterList>
                                        <label *ngFor="let value of filteredList | async" class="filter-list__item"
                                            [ngClass]="
                                {'filter-list__item--disabled':value.count ===0}"
                                            (click)="toggleSelectValue(value._id, value,$event)">
                                            <ng-container *ngIf="value.name">
                                                <span *ngIf="multiple"
                                                    class="filter-list__input input-check pointer-events-none">
                                                    <span class="input-check__body">
                                                        <input [checked]="value.selected"  [disabled]="value.count ===0" class="input-check__input"
                                                            type="checkbox">
                                                        <span class="input-check__box"></span>
                                                        <app-icon class="input-check__icon" name="check-9x7" size="9x7">
                                                        </app-icon>
                                                    </span>
                                                </span>
                                                <div *ngIf="!multiple" class="filter-list__input">
                                                    <div [class.cb-active]="value.selected"
                                                        class="cb-radio rounded-full"> </div>
                                                </div>
                                                <span class="filter-list__title">{{
                                                    translateHelper.localize(value?.name) }}</span>
                                                <span class="filter-list__counter">{{ value.count }}</span>
                                            </ng-container>
                                        </label>
                                    </div>

                                </ng-scrollbar>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<!--   <mat-form-field [appearance]="appearance" [floatLabel]="floatLabel" class="w-full">
    <mat-label>{{label}}</mat-label>
    <mat-select [formControl]="control" [multiple]="multiple" (selectionChange)="onChange($event.value)" [placeholder]="placeholder">

        <mat-option *ngIf="multiple">
            <ngx-mat-select-search [alwaysRestoreSelectedOptionsMulti]="true" [formControl]="FilterCtrl" placeholderLabel="{{'search'|translate}}" noEntriesFoundLabel="No matching"></ngx-mat-select-search>
        </mat-option>

        <mat-option *ngIf="!multiple" selected [value]="null">{{"please_select"|translate}} {{label}}</mat-option>

        <ng-container *ngIf="!multiple">
            <mat-option class="font-bold" *ngFor="let value of selectList" [value]="value._id">
                {{translateHelper.localize(value.name)}}
            </mat-option>
        </ng-container>

        <ng-container *ngIf="multiple">
            <mat-option class="font-bold" *ngFor="let value of filteredList | async" [value]="value._id">
                {{translateHelper.localize(value.name)}}
            </mat-option>
        </ng-container>
    </mat-select>
</mat-form-field> -->